import { ComponentProps } from "react";

import styles from "./drawer-footer.module.css";

export type DrawerFooterProps = ComponentProps<"div">;

export const DrawerFooter = ({
  children,
  className = "",
  ...props
}: DrawerFooterProps) => {
  return (
    <div className={`${styles.Container} ${className}`} {...props}>
      {children}
    </div>
  );
};
